export const FETCH_REPORTS_SUCCESS = 'fetch_reports_success'
export const CREATE_REPORTS_SUCCESS = 'create_sales_orders_success'
export const FETCH_REPORT_DETAIL_SUCCESS = 'fetch_report_detail_success'
